// footer button rediect to klaviyo teaser 
document.addEventListener("DOMContentLoaded", function () {
  const shopBtn = document.querySelector('a.btnn.click-btn[href="/collections/all"]');

  if (!shopBtn) return;

  shopBtn.addEventListener("click", function (e) {
    e.preventDefault(); // stop redirect

    let attempts = 0;
    const interval = setInterval(() => {
      const teaser = document.querySelector('[data-testid="animated-teaser"] span[role="button"]');

      if (teaser) {
        teaser.click();
        clearInterval(interval);
      }

      attempts++;
      if (attempts > 10) {
        clearInterval(interval);
      }
    }, 200);
  });
});

// footer button rediect to klaviyo teaser  end

// ===================================================================================


// Stop Audio from product page
document.addEventListener("DOMContentLoaded", function () {

  function stopMedia() {
    document.querySelectorAll("audio, video").forEach(el => {
      el.pause();
      el.currentTime = 0;
      el.muted = true;
    });
  }

  // run immediately
  stopMedia();

  // run again after delays (for apps like Klaviyo, widgets, etc.)
  setTimeout(stopMedia, 1000);
  setTimeout(stopMedia, 3000);
});
// Stop Audio from product page end


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#Scroller-template--26202342850855__banner_ayMFHG");
  if (!container) return;

  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return;

  const slides = Array.from(container.children);

  // Create track
  const track = document.createElement("div");
  track.classList.add("hdt-slider-track");

  slides.forEach((slide) => {
    slide.classList.add("hdt-slide");
    track.appendChild(slide);
  });

  container.innerHTML = "";
  container.classList.add("hdt-slider");
  container.appendChild(track);

  // ===== SINGLE ARROW WRAPPER =====
  const nav = document.createElement("div");
  nav.className = "hdt-slider-nav";

  const prevBtn = document.createElement("button");
  const nextBtn = document.createElement("button");

  prevBtn.className = "hdt-slider-arrow prev";
  nextBtn.className = "hdt-slider-arrow next";

  prevBtn.innerHTML = "‹";
  nextBtn.innerHTML = "›";

  nav.appendChild(prevBtn);
  nav.appendChild(nextBtn);

  container.appendChild(nav);

  let index = 0;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  const update = () => {
    track.style.transform = `translateX(-${index * 100}%)`;
  };

  const next = () => {
    index = (index + 1) % slides.length;
    update();
  };

  const prev = () => {
    index = (index - 1 + slides.length) % slides.length;
    update();
  };

  // Events
  nextBtn.addEventListener("click", next);
  prevBtn.addEventListener("click", prev);

  // Swipe
  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  track.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
  });

  track.addEventListener("touchend", () => {
    if (!isDragging) return;
    isDragging = false;

    const diff = startX - currentX;

    if (diff > 50) next();
    else if (diff < -50) prev();
  });

  update();
});


document.addEventListener('DOMContentLoaded', function () {

  function handleVariantChange(variantId) {
    const block = document.querySelector('.varitaion-block-220v');

    if (!block) return;

    if (variantId == '50011772256551') {
      block.classList.add('active');
    } else {
      block.classList.remove('active');
    }
  }

  // Shopify standard variant change (Dawn + modern themes)
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    if (variant) {
      handleVariantChange(variant.id);
    }
  });

  // Fallback (for dropdown-based themes)
  const selector = document.querySelector('select[name="id"]');
  if (selector) {
    selector.addEventListener('change', function () {
      handleVariantChange(this.value);
    });
  }

});

// working on hover shop menu 

document.addEventListener("DOMContentLoaded", function () {
  const shopTab = document.querySelector('li[data-tab="SHOP"]');
  const shopMenu = document.querySelector('.shopblocklik[data-class="SHOP"]');

  let timeout;

  if (shopTab && shopMenu) {

    const openMenu = () => {
      clearTimeout(timeout);
      shopTab.classList.add("active");
      shopMenu.setAttribute("open", "");
      shopMenu.style.display = "block";
    };

    const closeMenu = () => {
      timeout = setTimeout(() => {
        shopTab.classList.remove("active");
        shopMenu.removeAttribute("open");
        shopMenu.style.display = "none";
      }, 200); // 👈 delay (adjust 150–300ms if needed)
    };

    shopTab.addEventListener("mouseenter", openMenu);
    shopTab.addEventListener("mouseleave", closeMenu);

    shopMenu.addEventListener("mouseenter", openMenu);
    shopMenu.addEventListener("mouseleave", closeMenu);
  }
});

// document.addEventListener('click', function (e) {

//   // run only on this exact page
//   if (!window.location.pathname.includes('/collections/open-box-products')) return;

//   const link = e.target.closest('hdt-card-product a[href]');

//   if (!link) return;

//   e.preventDefault();

//   if (window.LiveChatWidget) {
//     LiveChatWidget.call('show');
//     LiveChatWidget.call('maximize');
//   }

// });

// document.addEventListener('click', function (e) {

//   // only this page
//   if (!window.location.pathname.includes('/pages/open-box-deals')) return;

//   const wrapper = e.target.closest('.hdt-card-product__wrapper');

//   if (!wrapper) return;

//   // stop EVERYTHING (add to cart, link, any theme action)
//   e.preventDefault();
//   e.stopPropagation();

//   if (window.LiveChatWidget) {
//     LiveChatWidget.call('show');
//     LiveChatWidget.call('maximize');
//   }

// }, true);




// document.addEventListener('click', function (e) {

//   // ONLY this page
//   if (window.location.pathname !== '/pages/open-box-deals') return;

//   const wrapper = e.target.closest('.hdt-card-product__wrapper');

//   if (wrapper) {
//     e.preventDefault();
//     e.stopPropagation();

//     if (window.LiveChatWidget) {
//       LiveChatWidget.call('show');
//       LiveChatWidget.call('maximize');
//     }
//   }

// }, true);



// // -----------------------------
// // CHANGE ADD TO CART TEXT ONLY ON THIS PAGE
// // -----------------------------
// function updateButtons() {
//   if (window.location.pathname !== '/pages/open-box-deals') return;

//   document.querySelectorAll('.custom_Checkout').forEach(btn => {
//     btn.innerText = 'Contact Chat Support';
//   });
// }

// // run once
// updateButtons();

// // handle Shopify dynamic reloads
// const observer = new MutationObserver(() => {
//   updateButtons();
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom_chat_btn');
  if (!btn) return;
  e.preventDefault();

  if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
    window.LC_API.open_chat_window();
    return;
  }

  const widget = document.getElementById('chat-widget-container');
  if (widget) {
    widget.style.opacity = '1';
    widget.style.visibility = 'visible';
    widget.style.display = 'block';
  }
});